import React from "react";
import { Button } from "../../../../design/button";
import { TrashIcon } from "@heroicons/react/16/solid";
import { useCase } from "../../../../contexts/CaseContext";
import { useDeleteAlert } from "../../../../contexts/DeleteAlertProvider";
import { Parent } from "@visitproof/types";

interface DeleteParentButtonProps {
  parent: Parent;
}

const DeleteParentButton: React.FC<DeleteParentButtonProps> = ({ parent }) => {
  const { removeParentFromCase } = useCase();
  const { openAlert } = useDeleteAlert();

  const handleDelete = async (id: string) => {
    await removeParentFromCase(id);
  };

  const handleClick = () => {
    openAlert(
      parent,
      {
        displayName: "parent",
        onDelete: handleDelete,
        getId: (entity) => entity.id,
      }
    );
  };

  return (
    <Button type="button" color="red" onClick={handleClick}>
      <TrashIcon className="w-5 h-5" aria-hidden="true" />
    </Button>
  );
};

export default DeleteParentButton;












